import * as CUSTOMEVENTS from './Core6Events';
import Core6RowNudging from './Core6RowNudging';
import Core6Utilities from './Core6Utilities';

export default class Core6RowGUIUpdater {
  static updateParamImage(data) {
    const selectImageBtn = Core6Utilities.getJQueryElement('[data-core6-component-action=selectImage]');
    const value = selectImageBtn.attr('data-value');
    const rowId = selectImageBtn.attr('data-row-id');

    const featureImageContainers = Core6Utilities.getElementAll(`.feature_image_holder[data-row-id="${rowId}"]`);
    for (const featureImageContainer of featureImageContainers) {
      featureImageContainer.style.backgroundImage = `url("/large/${value}")`;
    }

    const mainContainer = Core6Utilities.getElement(`.core6-mainrow-container[data-row-id="${rowId}"]:not(.isTemplate)`);
    mainContainer.style.backgroundImage = `url("/large/${value}")`;
    mainContainer.setAttribute('data-core6_slider_images', value);
    mainContainer.setAttribute('data-core6_slider', true);

    const logoImage = mainContainer.querySelector('img.logo_image_holder');
    if (logoImage !== undefined && logoImage !== null) {
      logoImage.setAttribute('src', data);
    }

    Core6Utilities.getElement('body').dispatchEvent(CUSTOMEVENTS.RESET_SLIDER);
  }

  static updateParamTransition(rowId, value, data) {
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.attr('data-core6_slider_transition', value);
    Core6Utilities.replaceLoader(rowId, data);
  }

  static updateParamScrollNumbers(rowId, value, data) {
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.attr('data-core6_slider_show_numbers', value);
    Core6Utilities.replaceLoader(rowId, data);
  }

  static updateParamScrollArrows(rowId, value, data) {
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.attr('data-core6_slider_show_arrows', value);
    Core6Utilities.replaceLoader(rowId, data);
  }

  static updateParamScrollTime(rowId, value, data) {
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.attr('data-core6_scroll_time', value);
    Core6Utilities.replaceLoader(rowId, data);
  }

  static updateParamTheme(rowId, value, data) {
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.css('opacity', 1);
    Core6Utilities.replaceLoader(rowId, data);
  }

  static updateParamBlockLocked(rowId, value) {
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.data('block_locked', value);
    mainContainer.attr('data-block_locked', value);
    Core6RowNudging.refreshNudgeArrows();
  }

  static changeRowType(rowId, value) {
    //console.log('change row type');
    const innerContainer = Core6Utilities.getJQueryInnerRowContainer(rowId);
    innerContainer.removeClass('container');
    innerContainer.removeClass('container-fluid');
    if (value === 'fluid') {
      innerContainer.addClass('container-fluid');
    } else {
      innerContainer.addClass('container');
    }
  }

  static updateContainerBackground(rowId, value) {
    //console.log(`updateContainerBackground: ${value}`);
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.removeClass('primary_colour');
    mainContainer.removeClass('secondary_colour');
    mainContainer.removeClass('tertiary_colour');
    mainContainer.removeClass('highlight_colour');
    mainContainer.removeClass('primary_font_colour');
    mainContainer.removeClass('secondary_font_colour');
    mainContainer.removeClass('tertiary_font_colour');
    mainContainer.removeClass('highlight_font_colour');
    mainContainer.removeClass('solid_bg_colour');
    mainContainer.removeClass('main_text_colour');
    mainContainer.removeClass('main_text_reverse_colour');
    mainContainer.removeClass('solid_bg_darker_colour');
    mainContainer.removeClass('faded_font_colour');
    mainContainer.addClass(value);
  }

  static updateRowBackground(rowId, value) {
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    const row = mainContainer.find(`.core6-innerrow-container[data-row-id="${rowId}"] .row_equal[data-row-id="${rowId}"]`);
    row.removeClass('primary_colour');
    row.removeClass('secondary_colour');
    row.removeClass('tertiary_colour');
    row.removeClass('highlight_colour');
    row.removeClass('primary_font_colour');
    row.removeClass('secondary_font_colour');
    row.removeClass('tertiary_font_colour');
    row.removeClass('highlight_font_colour');
    row.removeClass('solid_bg_colour');
    row.removeClass('main_text_colour');
    row.removeClass('main_text_reverse_colour');
    row.removeClass('solid_bg_darker_colour');
    row.removeClass('faded_font_colour');
    row.addClass(value);
  }

  static updateColours(rowId, param, value) {
    //console.log('updateColours');
    //console.log(`.core6-mainrow-container[data-row-id="${rowId}"] .${param}`);
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    const container = mainContainer.find(`.${param}`);
    //console.log(container);
    container.removeClass('primary_colour');
    container.removeClass('secondary_colour');
    container.removeClass('tertiary_colour');
    container.removeClass('highlight_colour');
    container.removeClass('primary_font_colour');
    container.removeClass('secondary_font_colour');
    container.removeClass('tertiary_font_colour');
    container.removeClass('highlight_font_colour');
    container.removeClass('solid_bg_colour');
    container.removeClass('main_text_colour');
    container.removeClass('main_text_reverse_colour');
    container.removeClass('solid_bg_darker_colour');
    container.removeClass('faded_font_colour');
    container.addClass(value);
  }

  static updateMinHeight(rowId, param, value) {
    //console.log('updateMinHeight');
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.css('min-height', `${value}px`);
  }

  static updateColour(rowId, selector, value) {
    //console.log('updateColour');
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    const mainBar = mainContainer.find(selector);
    if (mainBar !== undefined) {
      const classList = mainBar.attr('class').split(/\s+/);
      $.each(classList, (index, item) => {
        if ((~item.indexOf('colour')) && !(~item.indexOf('font')) && !(~item.indexOf('text'))) {
          //console.log(`Removing BG Class: ${item}`);
          mainBar.removeClass(item);
        }
      });
    }
    mainBar.addClass(value);
  }

  static updateFontColour(rowId, selector, value) {
    //console.log('updateFontColour');
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    const mainBar = mainContainer.find(selector);
    if (mainBar !== undefined) {
      const classList = mainBar.attr('class').split(/\s+/);
      $.each(classList, (index, item) => {
        if ((~item.indexOf('font')) || (~item.indexOf('text'))) {
          //console.log(`Removing Font Class: ${item}`);
          mainBar.removeClass(item);
        }
      });
    }
    mainBar.addClass(value);
  }

  static genericParams(rowId, param, value, response) {
    const json = response;
    const jsonLength = json.length;
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    const innerContainer = $(`.core6-mainrow-container[data-row-id=${rowId}]:not(.isTemplate) .core6-innerrow-container[data-row-id=${rowId}]`);
    const bottomPanel = mainContainer.find('.bottom_panel');

    for (let i = 0; i < jsonLength; i += 1) {
      switch (json[i].param) {
        case 'main_bar_colour':
          Core6RowGUIUpdater.updateColour(rowId, '[data-main_bar_colour]', value);
          break;
        case 'above_bar_colour':
          Core6RowGUIUpdater.updateColour(rowId, '[data-above_bar_colour]', value);
          break;
        case 'main_text_colour':
          Core6RowGUIUpdater.updateFontColour(rowId, '[data-main_text_colour]', value);
          break;
        case 'arrow_colour':
          Core6RowGUIUpdater.updateColour(rowId, '[data-arrow_colour]', value);
          break;
        case 'home_colour':
          Core6RowGUIUpdater.updateColour(rowId, '[data-home_colour]', value);
          break;
        case 'button_text_colour':
          Core6RowGUIUpdater.updateFontColour(rowId, '[data-button_text_colour]', value);
          break;
        case 'button_background':
          Core6RowGUIUpdater.updateColour(rowId, '[data-button_background]', 'button_background', value);
          break;
        case 'remove_bootstrap_padding':
          // Do Nothing
          break;
        case 'bottom_panel_opacity':
          if (bottomPanel) {
            bottomPanel.css('background-color', `rgba(0, 0, 0, ${value})`);
          }
          break;
        case 'row_type':
          innerContainer.removeClass('container');
          innerContainer.removeClass('container-fluid');
          if (json[i].value === 'fluid') {
            innerContainer.addClass('container-fluid');
          } else {
            innerContainer.addClass('container');
          }
          break;
        case 'voffset':
          mainContainer.removeClass('voffset');
          mainContainer.removeClass('voffset1');
          mainContainer.removeClass('voffset2');
          mainContainer.removeClass('voffset3');
          mainContainer.removeClass('voffset4');
          mainContainer.removeClass('voffset5');
          mainContainer.removeClass('voffset6');
          mainContainer.removeClass('voffset7');
          mainContainer.removeClass('voffset8');
          mainContainer.removeClass('voffset9');
          mainContainer.addClass(json[i].value);
          break;
        case 'padding_top':
          mainContainer.removeClass('padd_top');
          mainContainer.removeClass('padd_top1');
          mainContainer.removeClass('padd_top2');
          mainContainer.removeClass('padd_top3');
          mainContainer.removeClass('padd_top4');
          mainContainer.removeClass('padd_top5');
          mainContainer.removeClass('padd_top6');
          mainContainer.removeClass('padd_top7');
          mainContainer.removeClass('padd_top8');
          mainContainer.removeClass('padd_top9');
          mainContainer.addClass(json[i].value);
          break;
        case 'padding_bottom':
          mainContainer.removeClass('padd_bottom');
          mainContainer.removeClass('padd_bottom1');
          mainContainer.removeClass('padd_bottom2');
          mainContainer.removeClass('padd_bottom3');
          mainContainer.removeClass('padd_bottom4');
          mainContainer.removeClass('padd_bottom5');
          mainContainer.removeClass('padd_bottom6');
          mainContainer.removeClass('padd_bottom7');
          mainContainer.removeClass('padd_bottom8');
          mainContainer.removeClass('padd_bottom9');
          mainContainer.addClass(json[i].value);
          break;
        case 'container_background':
          Core6RowGUIUpdater.updateContainerBackground(rowId, json[i].value);
          break;
        case 'cookie_warning_container':
          Core6RowGUIUpdater.updateColour(rowId, `[data-${param}]`, json[i].value);
          // Core6RowGUIUpdater.updateCookieWarningBackground(rowId, json[i].value);
          break;
        case 'row_background':
          Core6RowGUIUpdater.updateRowBackground(rowId, json[i].value);
          break;
        case 'slider_height':
          mainContainer.find('[data-core6-component-action=showMediaPicker]').css('height', json[i].value);
          mainContainer.find('.row_image').css('height', json[i].value);
          break;
        default:
          // Don't do anything
          break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6RowGUIUpdater.js